// extracted by mini-css-extract-plugin
module.exports = {"items-block":"content_items-block__tXsTV","header":"content_header__kgSGX","items":"content_items__bsQWy","card-skeleton":"content_card-skeleton__2Csyy"};